<section>
  <nz-spin [nzSpinning]="this.loading">
    <div class="space-y-[20px]">
      <nz-card *ngIf="this.agent !== null" class="bg-white space-y-[20px]">
        <h4>{{ 'itineraries.viewAgent.agent' | transloco }}</h4>
        <nz-divider></nz-divider>
        <div class="grid grid-cols-1">
          <div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.agencyName' | transloco }}: </p>
              <p
                class="text-[#444444]">{{ this.agent?.name || getEmptyValue() }}</p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.contactName' | transloco }}: </p>
              <p
                class="text-[#444444]">{{ this.contact?.name || getEmptyValue() }}</p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.email' | transloco }}: </p>
              <p class="text-[#444444]"> {{ this.contact?.email || getEmptyValue() }}</p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.contactNo' | transloco }}: </p>
              <p class="text-[#444444]"> {{ this.contact?.contactNo || getEmptyValue() }}</p>
            </div>
          </div>
        </div>
      </nz-card>
      <nz-card class=" bg-white space-y-[20px]">
        <h4>{{ getUpdatedCostingTitle() }}</h4>
        <nz-divider></nz-divider>
        <div class="grid grid-cols-1">
          <ng-container *ngIf="this.b2b?.costing?.viewType === 'custom'">
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.costPerAdult' | transloco }}: </p>
              <p
                class="text-[#444444]"> {{ this.currency }} {{ this.b2b?.costing?.costPerAdult | number : '2.0' }}</p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.costPerChild' | transloco }}: </p>
              <p
                class="text-[#444444]">{{ this.currency }} {{ this.b2b?.costing?.costPerChild | number : '2.0' }}</p>
            </div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.costPerInfant' | transloco }}: </p>
              <p class="text-[#444444]">{{ this.currency }} {{ this.b2b?.costing?.costPerInfant | number : '2.0' }}</p>
            </div>
          </ng-container>
          <ng-container *ngIf="this.b2b?.costing?.viewType !== 'custom'">
            <div *ngIf="this.b2b?.costing?.viewType === 'person'" class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.costPerPerson' | transloco }}: </p>
              <p
                class="text-[#444444]"> {{ this.currency }} {{ this.b2b?.costing?.personCost | number : '2.0' }}</p>
            </div>
            <div *ngIf="this.b2b?.costing?.viewType === 'total'" class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.totalCost' | transloco }}: </p>
              <p
                class="text-[#444444]"> {{ this.currency }} {{ this.b2b?.costing?.grandTotal | number : '2.0' }}</p>
            </div>
          </ng-container>
        </div>
      </nz-card>
      <nz-card class=" bg-white space-y-[20px]">
        <h4>{{ 'itineraries.viewAgent.updatedCompanyInformation' | transloco }}</h4>
        <nz-divider></nz-divider>
        <div class="grid grid-cols-2">
          <div>
            <img *ngIf="this.b2b?.customer?.logo"
                 class="w-[16.5rem] h-[3.875rem] rounded-xl object-contain object-left"
                 [src]="this.b2b?.customer?.logo"
                 alt="Company Logo"/>
          </div>
          <div>
            <div class="flex flex-row gap-2">
              <p class="text-[#444444]">{{ 'itineraries.viewAgent.companyName' | transloco }}: </p>
              <p
                class="text-[#444444]">{{ this.b2b?.customer?.companyName || getEmptyValue() }}</p>
            </div>
            <div class="flex flex-row gap-2">

              <p class="text-[#444444]" *ngIf="!this.b2b?.customer?.websiteLink">{{ 'itineraries.viewAgent.websiteLink' | transloco }}: {{ getEmptyValue() }}</p>
              <p class="text-[#444444]" *ngIf="this.b2b?.customer?.websiteLink">
                {{ 'itineraries.viewAgent.websiteLink' | transloco }}: <a href="http://localhost:4200.com/sdsdsds" target="_blank" class="text-inherit no-underline cursor-pointer">
                 http://localhost:4200.com/sdsdsds
              </a></p>
            </div>
          </div>
        </div>
        <nz-divider></nz-divider>
        <div class="grid grid-cols-1 space-y-5">
          <h5>{{ 'itineraries.viewAgent.companyDescription' | transloco }}</h5>
          <div>
            <p class="text-[#444444]"> {{ this.b2b?.customer?.summary || getEmptyValue() }}</p>
          </div>
        </div>
      </nz-card>
    </div>
  </nz-spin>
</section>
